// extracted by mini-css-extract-plugin
module.exports = {"controls":"style_controls__WO4O_","sep":"style_sep__1r8CH","button":"style_button__1Y_45","active":"style_active__3G3qg"};